module.exports = require("./../../_gen/openfl/filters/ConvolutionFilter");